import { LandingRule } from './types';

export function buildFinalRule(otherwise: LandingRule['otherwise']) {
  return {
    checker: () => false,
    otherwise,
  };
}
